
import Offers from '@/graphql/queries/products/Offers'

export default {
  vessel: {
    title: {
      fontSize: '3xl',
      color: 'black',
      width: 'full'
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.page = await $content(locale, 'pages/offers').fetch()

    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: Offers,
      variables: { first: 4, order: 'sortOrder_ASC', where: { onSale: true } }
    })

    this.offers = data.nodes
  },
  data() {
    return {
      offers: null,
      page: null
    }
  }
}
